declare global {
  interface Window{
    grecaptcha: any;
  }
}
export interface ICaptcha{
  privateKey: string;
  publicKey: string;
}
export interface IVerifyCaptchaResponse {
  success: boolean;
}
export interface GlobalValueState {
  isLoading: boolean;
  toast: ToastModel;
  confirm: ConfirmModel;
  activeMenu: string;
  isSignIn: boolean;
  captcha: ICaptcha;
}

export interface ToastModel {
  isShowToast: boolean;
  status: string;
  message: string;
  duration: number;
  type: ToastType;
}
export enum ToastType {
  success,
  warn,
  info,
  error,
  default,
  dark,
}
export interface ConfirmModel {
  onClose: any;
  onYes: any;
  isModal: boolean;
  title: string;
  message: string;
  okText:string;
  
}
